// @ts-ignore
import * as ramda from 'ramda';

// This is a super complicated way of implementing XOR in javascript. This
// means that is we are sorting assending, and not sorting user, use an
// assending sort. If we are sorting by user, sort descending. This is
// because the logical sort order for strings is opposite the sort order for
// numbers.
// This is logically equalivent to sortAscending ^^ sortByUser
export function getSortFunc(isAscending: boolean, isAlphabetical: boolean) {
    return (isAscending && !isAlphabetical) || (!isAscending && isAlphabetical)
        ? ramda.ascend
        : ramda.descend;
}
